export default __webpack_public_path__ + "static/media/Arrow 2 Right.daab747b.svg";